import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bank-account-view',
  templateUrl: './bank-account-view.component.html',
  styleUrls: ['./bank-account-view.component.css']
})
export class BankAccountViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
